import { CRITICALITY_LABELS } from '@/constants/criticalitylabels.constants';

const getPonduranceScoreSeverity = (score: number) => {
  switch (true) {
    case score < 30:
      return CRITICALITY_LABELS.LOW;
    case score >= 30 && score < 70:
      return CRITICALITY_LABELS.MEDIUM;
    case score >= 70 && score < 90:
      return CRITICALITY_LABELS.HIGH;
    case score >= 90:
      return CRITICALITY_LABELS.CRITICAL;
    default:
      return CRITICALITY_LABELS.LOW;
  }
};

export default getPonduranceScoreSeverity;
